import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { IUpdateSchedulePayload } from 'src/interfaces/Schedule';
import { queryKeys, requestCCApi } from 'src/utils';

export const useUpdateSchedule = () => {
  return useMutation({
    mutationFn: async (payload: IUpdateSchedulePayload) => {
      const { id, ...data } = payload;

      const url = `/schedules/${id}`;
      const response = await requestCCApi({
        url,
        method: 'PUT',
        data: {
          data,
        },
      });

      return response;
    },
    onSuccess: async () => {
      await queryClient.refetchQueries(queryKeys.components.invalidateAll());
      await queryClient.refetchQueries(
        queryKeys.componentListing.invalidateAll(),
      );
      await queryClient.refetchQueries(queryKeys.schedules.invalidateAll());
      await queryClient.refetchQueries(
        queryKeys.getCalendarSidebarDetails.invalidateAll(),
      );
      await queryClient.refetchQueries(
        queryKeys.getCalendarEvents.invalidateAll(),
      );
      await queryClient.refetchQueries(
        queryKeys.scheduleOverview.invalidateAll(),
      );
    },
  });
};
